import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
export const MaintainAspectRatio = ({ height, width, children }) => (
/* https://css-tricks.com/aspect-ratio-boxes/ */
_jsx("div", Object.assign({ css: css `
			/* position relative to contain the absolutely positioned iframe plus any Overlay image */
			position: relative;
			padding-bottom: ${(height / width) * 100}%;

			iframe {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
			}
		` }, { children: children }), void 0));
